import React from 'react';
import classNames from 'classnames';
import MenuIconOpen from 'jl-design-system/elements/icons-jb/Close24PxOutlined';
import MenuIconClosed from 'jl-design-system/elements/icons-jb/Menu24PxOutlined';

// eslint-disable-next-line import/no-named-as-default
import AccountLinks from '../account-links/AccountLinks';
// eslint-disable-next-line import/no-named-as-default
import Basket from '../basket/Basket';

import styles from './user-tools.scss';

function UserTools({
  isMenuOpen,
  onMenuButtonClick,
  isBrandPromiseActive = false,
  isTypeaheadOpen,
}) {
  const menuButtonChildren = (
    <>
      <span className={styles.visuallyHidden}>
        {isMenuOpen ? 'Close' : 'Menu'}
      </span>

      {isMenuOpen ? (
        <MenuIconOpen
          data-testid="nav-menu-close-icon"
          box
          title="Close Menu"
        />
      ) : (
        <MenuIconClosed data-testid="nav-menu-icon" box title="Open Menu" />
      )}

      <span
        className={classNames(styles.navListItemLabel, {
          [styles.navListItemLabel__bp]: isBrandPromiseActive,
        })}
      >
        Menu
      </span>
    </>
  );

  return (
    <nav
      data-testid="user-tools-nav"
      className={classNames(styles.nav, {
        [styles.nav__bp]: isBrandPromiseActive,
        [styles.nav__bp__active]: isBrandPromiseActive && isTypeaheadOpen,
      })}
    >
      <ul
        className={classNames(styles.navList, {
          [styles.navList__bp]: isBrandPromiseActive,
        })}
      >
        <li
          className={classNames(styles.navListItem, {
            [styles.navListItem__bp]: isBrandPromiseActive,
          })}
        >
          <AccountLinks showGreeting />
        </li>
        <li
          className={classNames(styles.navListItem, {
            [styles.navListItem__bp]: isBrandPromiseActive,
          })}
        >
          <Basket>
            <span
              className={classNames(styles.navListItemLabel, {
                [styles.navListItemLabel__bp]: isBrandPromiseActive,
              })}
            >
              Basket
            </span>
          </Basket>
        </li>
        <li
          className={classNames(styles.navListItem, styles.menu, {
            [styles.navListItem__bp]: isBrandPromiseActive,
          })}
        >
          <a
            href="/menu"
            className={styles.navListItemLink}
            data-testid="nav-link--menu"
            onClick={onMenuButtonClick}
            role="button"
            aria-expanded={isMenuOpen}
            aria-controls="main-navigation-menu"
          >
            {menuButtonChildren}
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default UserTools;
